

export default [
  {
    path: '/subject-electives',
    name: 'subject-elective',
    meta: { requiresAuth: true },
    component: () => import('@/pages/subject-elective/index.vue'),
  }
]
